import styled from 'styled-components';
import MFlexbox from '../../atoms/MFlexbox';
import { MText } from '../../atoms/MText';

export const PriceDetailsCon = styled(MFlexbox)`
  ${({ isInline }) => (isInline ? `display: inline-flex` : null)};
  font-family: ${({ fontFamily }) => fontFamily};
  text-align: ${({ textAlignment }) => textAlignment};
  justify-content: ${({ textAlignment }) => textAlignment};
`;

export const DeductedPrice = styled(MText)`
  color: ${props => `${props.color}80`};
  text-decoration: ${props =>
    props.isStrikeThrough ? 'line-through' : 'none'};
`;

export const Discount = styled(MText)`
  ${({ isWrap }) => (!isWrap ? `min-width: fit-content` : null)};
`;
